import Button from './button/Button';

export default class Selector extends Phaser.GameObjects.Container {
    private buttons: Button[] = [];
    private bg!: Phaser.GameObjects.Image;
    public user!: Button;
    private squads!: Button;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupBG();
        this.setupButtons();
    }

    setupBG() {
        let frame = 'gui/leaderboard/bottom_selector_bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.add(this.bg);
    }

    setupButtons() {
        let x = 157;
        let y = 0;

        this.user = new Button(this.scene, -x, y, 'User');
        this.user.on('click', this.onButtonClick, this);
        this.add(this.user);

        this.squads = new Button(this.scene, x, y, 'Squads');
        this.squads.on('click', this.onButtonClick, this);
        this.add(this.squads);

        this.buttons.push(this.user);
        this.buttons.push(this.squads);
    }

    onButtonClick(button: Button) {
        for (let button of this.buttons) button.deselect();
        button.select();

        this.emit('leaderboard_selected', button.id);
    }
}
